<script setup>
import { onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { useOfficeOfferStore } from '@stores/useOfficeOfferStore';
import { trans, transchoice } from '@elements/translation';
import { eventBus } from '@tools/event-bus';
import OfferPreview from '@organisms/offer/OfferPreview.vue';

const officeOfferStore = useOfficeOfferStore();
const { selectedOffers, notSelectedOffers } = storeToRefs(officeOfferStore);

// same as assets/scripts/_03_organisms/offer/multioffice/office-configurator-launcher.js
const showMultiOffice = () => {
  eventBus.dispatchEvent(new Event('multioffice-show-slidein'));
};

const { isMobile } = storeToRefs(useScreensizeStore());

onBeforeMount(() => {
  const offers = document.querySelector('[data-combinator-offers]');
  offers.remove();
});
</script>

<template>
  <div class="offer-content__other-offers">
    <div class="offer-selection">
      <h3 class="offer-selection__title">
        {{ trans('offer.selection.label') }}
      </h3>

      <div class="offer-selection__offers">
        <OfferPreview
          v-for="offer in selectedOffers"
          :key="offer.hashId"
          :offer="offer"
          class="selected"
          @click="showMultiOffice"
        />
      </div>

      <div class="btn btn--primary" @click="showMultiOffice">
        {{ trans('offer.other_offers.modify') }}
      </div>
    </div>

    <div v-show="notSelectedOffers.length > 0" class="offer-address">
      <h3 class="offer-address__title">
        {{ transchoice('offer.address.label', { count: notSelectedOffers.length }) }}
      </h3>

      <div class="offer-address__offers">
        <a
          v-for="offer in notSelectedOffers.slice(0, 4)"
          :key="offer.hashId"
          :href="offer.public_url"
          :target="isMobile ? '_self' : '_blank'"
        >
          <OfferPreview
            :offer="offer"
            class="not-selected"
          />
        </a>
      </div>

      <div class="btn" @click="showMultiOffice">
        {{ trans('offer.other_offers.view_all') }}
      </div>
    </div>
  </div>
</template>
